<template>
	<div class="page-2025">

		<div class="guide-box" :class="{ on: showSlide }">
			<div class="page0-text ani2" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
							swiper-animate-delay="0.1s">
				时光的列车匆匆驶过，<br>
				又一年征途满载而归。 <br>
				这份专属于你的年度回顾，已整理完毕。 <br>
				现在，就让我们一起回到2025，<br>
				细数那些闪光的足迹。
			</div>

			<div class="page0-img ani2" swiper-animate-effect="fadeInLeft" swiper-animate-duration="1s"
				swiper-animate-delay="0.4s">
				<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page0-img.png" alt="" srcset="">
			</div>

			<div class="page0-2025 ani2" swiper-animate-effect="zoomIn" swiper-animate-duration="1s"
				swiper-animate-delay="0.8s">
				<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page0-2025.png" alt="" srcset="">
			</div>


			<div class="foot fcc-h">
				<div class="open gif" @click="open">
					<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/btn-enter.png" alt="" srcset="" />
				</div>

			</div>


		</div>



		<div class="swiper-container swiper-container2" v-if="showPage">
			<div class="swiper-wrapper">

				<div class="swiper-slide slide-page1">
					<div class="page-inner ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
							swiper-animate-delay="0.1s">
							<div>



							</div>
						<div class="fc row">
							<span>亲爱的</span>
							<span class="page-text">{{data.staff_name}}</span>
							<span>,</span>
						</div>
						<div class="fc row">
							还记得
							<span class="page-num">{{ data.entry_date_year }}</span>
							年
							<span class="page-num">{{ data.entry_date_month }}</span>
							月
							<span class="page-num">{{ data.entry_date_day }}</span>
							日吗？
						</div>
						<div class="fc row">
							那是你与通号院故事的起点,
						</div>
						<div class="fc row">
							至今已并肩走过
							<span class="page-num">{{ data.entry_day }}</span>
							天，
						</div>
						<div class="fc row">
							我们一起播种，一起成长，<br>
							这段时光，因你而珍贵。
						</div>







					</div>

					<div class="page1-img4 ani"  swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.1s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page1-img4.png" alt="" srcset="">
					</div>

					<div class="page1-img3 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.2s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page1-img3.png" alt="" srcset="">
					</div>
						<div class="page1-img8 ani" swiper-animate-effect="fadeIn" swiper-animate-duration="1s"
									swiper-animate-delay="0.5s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page1-img8.png" alt="" srcset="">
					</div>
					<div class="page1-img2 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.3s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page1-img2.png" alt="" srcset="">
					</div>
					<div class="page1-img1 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.4s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page1-img1.png" alt="" srcset="">
					</div>
					<div class="page1-img5 ani" swiper-animate-effect="fadeInLeft" swiper-animate-duration="1s"
									swiper-animate-delay="0.55s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page1-img5.png" alt="" srcset="">
					</div>
					<div class="page1-img6 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.6s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page1-img6.png" alt="" srcset="">
					</div>




				</div>
				<div class="swiper-slide slide-page2" v-if="data.at_check_time_last_1y">
					<div class="page-inner ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
							swiper-animate-delay="0.1s">
						<div class=" row">
							这一年，<br>
							你全心投入，始终向前。




						</div>
						<div class="fc row">
							还记得
							<span class="page-num">{{ data.at_check_time_last_1y_month }}</span>
							月
							<span class="page-num">{{ data.at_check_time_last_1y_day }}</span>
							日吗？

						</div>
						<div class=" row">
							你工作至深夜，在某个关键节点上，你选择<br>了全力以赴。<br>
							我们知道，所有静默的奋斗，都正在让改变<br>发生。
						</div>

					</div>
					<div class="page2-img2 ani" v-if="!isWoman"  swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.1s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page2-man.png" alt="" srcset="">
					</div>
					<div class="page2-img2 ani" v-else swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.1s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page2-woman.png" alt="" srcset="">
					</div>

					<!-- <div class="page2-img1 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.1s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page2-img1.png" alt="" srcset="">
					</div> -->
				</div>

				<div class="swiper-slide slide-page3">
					<div class="page-inner ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
							swiper-animate-delay="0.1s">
						<div class=" row">
							这一年，你参加了


							<span class="page-num">{{ data.join_succ_conf_cnt_1y }}</span>
							场会议，

						</div>
						<div class=" row">
							其中
							<span class="page-num">{{data.join_succ_video_conf_cnt_1y}}</span>
							场在云端相聚，

						</div>
						<div class=" row">
							累计投入
							<span class="page-num">{{ data.join_succ_conf_len_1y }}</span>
							分钟。

						</div>
						<div class=" row">
							你专注倾听，真诚建言，正是这些看起来平<br>凡的日常，串联起通号院稳健向前的轨迹。
						</div>

					</div>

					<div class="page3-img2 ani" swiper-animate-effect="fadeIn" swiper-animate-duration="1s"
									swiper-animate-delay="0.9s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page3-img2.png" alt="" srcset="">
					</div>

					<!-- <div class="page3-img3 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.3s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page3-img3.png" alt="" srcset="">
					</div> -->

					<div class="page3-img4 ani" swiper-animate-effect="fadeIn" swiper-animate-duration="1s"
									swiper-animate-delay="0.6s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page3-img4.png" alt="" srcset="">
					</div>
					<div class="page3-img1 ani" swiper-animate-effect="fadeIn" swiper-animate-duration="1s"
									swiper-animate-delay="0.7s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page3-img1.png" alt="" srcset="">
					</div>
					<div class="page3-img5 ani" swiper-animate-effect="fadeIn" swiper-animate-duration="1s"
									swiper-animate-delay="0.8s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page3-img5.png" alt="" srcset="">
					</div>

					<div class="page3-img6 ani" swiper-animate-effect="fadeIn" swiper-animate-duration="1s"
									swiper-animate-delay="0.1s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page3-img6.png" alt="" srcset="">
					</div>




					<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page3-footer.png" alt="" srcset="" class="page3-footer ani" swiper-animate-effect="fadeIn" swiper-animate-duration="1s"
									swiper-animate-delay="0.8s"/>

				</div>


				<div class="swiper-slide slide-page4">
					<div class="page-inner ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
							swiper-animate-delay="0.1s">
						<div class=" row">
							这一年，


						</div>
						<div class=" row">
							你使用了<span class="page-num">{{data.use_micro_app_cnt_1y}}</span>个通好办应用，
						</div>
						<div class="fc row">
							你发起
							<span class="page-num">{{ data.process_inst_submit_cnt_1y }}</span>
							个审批，处理
							<span class="page-num">{{ data.process_inst_operate_cnt_1y }}</span>
							个审批，
						</div>
						<div class=" row">
							你的严谨与担当，是通号院前行路上<br>
							一份踏实而珍贵的力量。
						</div>

					</div>



					<div class="page4-img5 ani" v-if="!isWoman" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.1s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page4-man.png" alt="" srcset="">
					</div>

					<div class="page4-img5 ani" v-else swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.1s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page4-woman.png" alt="" srcset="">
					</div>

					<div class="page4-img1 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.3s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page4-img1.png" alt="" srcset="">
					</div>


					<div class="page4-img4 ani" swiper-animate-effect="fadeIn" swiper-animate-duration="1s"
									swiper-animate-delay="0.2s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page4-img4.png" alt="" srcset="">
					</div>

					<div class="page4-img2 ani" swiper-animate-effect="fadeInLeft" swiper-animate-duration="1s"
									swiper-animate-delay="0.4s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page4-img2.png" alt="" srcset="">
					</div>

					<div class="page4-img3 ani" swiper-animate-effect="fadeInLeft" swiper-animate-duration="1s"
									swiper-animate-delay="0.5s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page4-img3.png" alt="" srcset="">
					</div>


				</div>

				<div class="swiper-slide slide-page5" v-if="data.project_manager>0">
					<div class="page-inner ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
							swiper-animate-delay="0.1s">
						<div class=" row">
							这一年，


						</div>
						<div class="fc row">
							你担任
							<span class="page-num">{{ data.project_manager }}</span>
							个项目的负责人

						</div>

						<div class="row">
							你用高效和精细，驱动进程； <br>
							以闭环与沉淀，积累底气。<br>
							感谢你让通号院这趟列车，<br>
							行得更稳，走得更远。
						</div>

					</div>



					<div class="page5-img2 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.3s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page5-img2.png" alt="" srcset="">
					</div>
					<div class="page5-img1 ani" swiper-animate-effect="fadeIn" swiper-animate-duration="1s"
									swiper-animate-delay="0.1s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page5-img1.png" alt="" srcset="">
					</div>


					<div class="page5-img4 ani" swiper-animate-effect="fadeIn" swiper-animate-duration="1s"
									swiper-animate-delay="0.4s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page5-img4.png" alt="" srcset="">
					</div>

					<div class="page5-img3 ani" v-if="!isWoman" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.5s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page5-man.png" alt="" srcset="">
					</div>
					<div class="page5-img3 ani" v-else swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.5s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page5-woman.png" alt="" srcset="">
					</div>

				</div>


				<div class="swiper-slide slide-page6"  v-if="data.duration>0">
					<div class="page-inner ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
							swiper-animate-delay="0.1s">
						<div class=" row">

							这一年，

						</div>
						<div class=" row">
							你出差累计<span class="page-num">{{ data.duration }}</span>天，

						</div>

						<div class="fc row">
							最常前往<span class="page-text">{{ data.city }}</span>市，
						</div>
						<div class="fc row">
							单次最长<span class="page-num">{{data.maxDuration || 0}}</span>天。
						</div>
						<div class="fc row">
							每一次出发，都传递我们专业与诚意；<br>
							每一程归来，都带回远方的信任与托付。
						</div>
					</div>


					<div class="page6-img3 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.1s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page6-img3.png" alt="" srcset="">
					</div>
					<div class="page6-img1 ani" swiper-animate-effect="fadeIn" swiper-animate-duration="1s"
									swiper-animate-delay="0.2s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page6-img1.png" alt="" srcset="">
					</div>
					<div class="page6-img2 ani" swiper-animate-effect="fadeIn" swiper-animate-duration="1s"
									swiper-animate-delay="0.3s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page6-img2.png" alt="" srcset="">
					</div>
					<div class="page6-img6 ani" swiper-animate-effect="fadeInLeft" swiper-animate-duration="1s"
									swiper-animate-delay="0.4s">

							<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page6-img6.png" alt="" srcset="">

					</div>
					<div class="page6-img4 ani" swiper-animate-effect="fadeInLeft" swiper-animate-duration="1s"
									swiper-animate-delay="0.6s">

							<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page6-man.png" alt="" srcset="">

					</div>

					<div class="page6-img5 ani" swiper-animate-effect="fadeInLeft" swiper-animate-duration="1s"
									swiper-animate-delay="0.4s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page6-woman.png" alt="" srcset="">
					</div>


				</div>
				<div class="swiper-slide slide-page7">
					<div class="page-inner ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
							swiper-animate-delay="0.1s">
						<div class=" row " >
							亲爱的通号院家人们：<br>
							<br>
							 　　时光轻缓，步履有声。感谢2025年里每一个全力以赴的你。以踏实为笔，以坚守为墨，各自的岗位上书写专属的精彩；用每一次攻坚克难、每一份默默耕耘，为通号院的成长筑牢了最坚实的根基。<br>
							　　愿2026年的我们，继续怀抱热爱，与通号院同心同行，并肩奔赴。
							收获下一个丰年。
						</div>

					</div>


					<div class="page7-img1 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s"
									swiper-animate-delay="0.1s">
						<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page7-img1.png" alt="" srcset="">
					</div>


					<img src="https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/page7-footer.png" alt="" srcset="" class="ani page7-footer"  swiper-animate-effect="fadeIn" swiper-animate-duration="1s"
									swiper-animate-delay="0.4s"/>

				</div>



			</div>


		</div>
		<div class="music" :class="{ on: !audioPaused }" @click="musicIconClick"></div>
		<!-- <div class="arrow" v-if="show" @click="arrowClick"></div> -->
		<div v-show="false">


			<audio :src="audioUrl" loop controls @error="playAudioError()" @ended="playAudioEnd()" style="display:none;"
				ref="audioVo" id="audioVo"></audio>

		</div>

		<!-- 首页 -->






		<!-- <i-loading v-if="showLoading"></i-loading> -->

		<!-- 截图 -->
		<div class="capture-pop" v-if="showImage" @click="showImage = !showImage">
			<img :src="image" alt="" @click.stop="">
			<p @click.stop="">
				{{ showRemark }}
			</p>
		</div>
	</div>
</template>

<script>
	import html2canvas from 'html2canvas';
	import '@/assets/animate.min.css';
	import Swiper from '@/assets/swiper.min.js'
	import {
		get2025NbData,
		getCropInfo,
		getNbData,
		sign
	} from "@/api/nb";
	import {
		pageSign,
		resetLogin
	} from "@/utils";
	import * as dd from 'dingtalk-jsapi';
	var mySwiper;
	var guide;
	export default {
		data() {
			return {
				isWoman:false,

				showPage: false,
				// 截图
				image: "",
				// 显示截图
				showImage: false,
				showSlide: false,
				show: true,
				audioUrl: 'https://parker-oss.oss-cn-shanghai.aliyuncs.com/mini/thy/2025/bg.mp3',
				// audioIsPlaying: false,
				audioPaused: false, //是否暂停
				showRemark: '',
				showLoading: false,
				data: {
					staff_name: '',
					//差旅一共出差多少天
					duration: '0',
					//城市
					city: '无',
					//单次出差最长时间是几天
					maxDuration: '0',
					//日期是什么时候
					date: '',
					date_month: '',
					date_day: '',
          //项目负责人
          project_manager:'0',
					//处理审批数
					process_inst_operate_cnt_1y: '0',
          //使用同好办应用次数
          use_micro_app_cnt_1y: '0',
					//发起审批数
					process_inst_submit_cnt_1y: '0',
					//入职时间
					entry_date: '',
					entry_date_year: '',
					entry_date_month: '',
					entry_date_day: '',
					//入职天数
					entry_day: '',
					//打卡天数
					at_check_days_1y: 0,
					//最晚打卡时间
					at_check_time_last_1y: '',
          //最晚打卡时间的月
					at_check_time_last_1y_month: '',
					//最晚打卡时间的日
					at_check_time_last_1y_day: '',
					//参加会议数
					join_succ_conf_cnt_1y: 0,
					//会议时长
					join_succ_conf_len_1y: 0,
					//视频会议数
					join_succ_video_conf_cnt_1y: 0,
					//祝福语
					title: '',
					content: '',
					//tb数量
					tbCount: '',
					//tb完成数量
					tbOverCount: '',
					html2ImgCotentShow: false




				}

			};
		},
		mounted() {
			var that = this
			that.$nextTick(() => {
				//debugger
				 that.init()


				// that.dataInit();

				pageSign().then(res => {
					that.showPage = true
					// that.init()
					that.dataInit();
					this.$refs.audioVo.currentTime = 0; //从头开始播放提示音
					//判断是否为安卓
					let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent
						.indexOf('Adr') > -1;
					if (isAndroid) {
						try {
							that.$refs.audioVo.play(); //播放
						} catch (e) {
							// 安卓
							dd.device.notification.alert({
								title: '提示',
								message: '请允许网站播放声音',
								onSuccess: function(result) {
									/*{}*/
									that.$refs.audioVo.play(); //播放
								},
								onFail: function(err) {}
							})
						}

					} else {
						that.$refs.audioVo.play(); //播放
					}
					// 点击
					// document.addEventListener('click', () => {
					// 	that.$refs.audioVo.play(); //播放
					// });
					// 监听鼠标移动的事件
					// document.addEventListener('mousemove', () => {
					// 	that.$refs.audioVo.play(); //播放
					// });


					document.addEventListener("WeixinJSBridgeReady", function() {
						//安卓无法自动播放，所以需要添加一个 按钮，点击后调用that.play(1) 才可以
						//that.play(1)
					}, false);
				})


			})

		},
		created() {

		},
		methods: {
			init() {
				var that = this



				var allBoxes = null
				var i = 0
				var j = 0
				var effect = null
				var style = null
				var duration = null
				var delay = null


				var b = document.querySelectorAll(".ani2");
				for (var i = 0; i < b.length; i++) b[i].style.visibility = "visible", effect = b[i].attributes[
					"swiper-animate-effect"] ? b[i].attributes["swiper-animate-effect"].value : "", b[i].className = b[
						i]
						.className + "  " + effect + " " + "animated", style = b[i].attributes["style"].value, duration = b[i]
							.attributes["swiper-animate-duration"] ? b[i].attributes["swiper-animate-duration"].value : "",
					duration && (
						style = style + "animation-duration:" + duration + ";-webkit-animation-duration:" + duration + ";"
					), delay =
					b[i].attributes["swiper-animate-delay"] ? b[i].attributes["swiper-animate-delay"].value : "", delay &&
					(style =
						style + "animation-delay:" + delay + ";-webkit-animation-delay:" + delay + ";"), b[i].setAttribute(
							"style",
							style)

			},
			dataInit() {
				let that = this;
				let userInfo = JSON.parse(localStorage.getItem('userInfo'));

				//debugger
				// let userInfo={}
				// userInfo.userid='555153375224281905'
				// userInfo.userid='220724115726071427'
				console.log('userInfo', userInfo);
				that.showLoading = true;
				get2025NbData({
					userId: userInfo.userid
				}).then(res => {
					var data = res.data;
					if (data.entry_date) {
            // 方法1：使用slice截取前10个字符
            let dateStr = data.entry_date.slice(0, 10);
						let entry_date = dateStr.split('-');
						data.entry_date_year = entry_date[0];
						data.entry_date_month = entry_date[1];
						data.entry_date_day = entry_date[2];
					}
          if(data.at_check_time_last_1y){
            let dateStr = data.at_check_time_last_1y.slice(0, 10);
            let entry_date = dateStr.split('-');

            data.at_check_time_last_1y_month = entry_date[1];
            data.at_check_time_last_1y_day = entry_date[2];
          }
					if (data.date) {
						let date = data.date.split('-');
						data.date_month = date[0];
						data.date_day = date[1];
					}
					if (!data.duration) {
						data.duration = 0;
						data.city = '无';
						data.maxDuration = 0;
					}
					//join_succ_conf_len_1y 处理数据 保留2位小数
					if (data.join_succ_conf_len_1y) {
						data.join_succ_conf_len_1y = Number(data.join_succ_conf_len_1y.toString().match(
							/^\d+(?:\.\d{0,2})?/));
					}
					//年度热词hotKey,分割
					if (data.hotKey) {
						let hotKeyArr = data.hotKey.split(',');
						//根据字数长度排序
						hotKeyArr.sort(function(a, b) {
							return a.length - b.length;
						});
						data.hotKey1 = hotKeyArr[0];
						data.hotKey2 = hotKeyArr[1];
						data.hotKey3 = hotKeyArr[2];
					}


					that.data = data;
					that.showLoading = false;
				})
				getCropInfo({
					appKey: ''
				}).then(res => {
					let cropInfo = res.data;
					// this.$toast();
					resetLogin(cropInfo);
				})
			},
			musicIconClick() {
				if (this.audioPaused) {
					//播放
					this.play(1)
				} else {
					this.play(2)
				}
			},
			play(status) {
				if (status === 1) {
					this.audioPaused = false
					this.$refs.audioVo.play()
					let audio = document.getElementById('audioVo')
					debugger
					audio.play()
				} else if (status === 2) {
					this.$refs.audioVo.pause()
					let audio = document.getElementById('audioVo')

					console.log('audio', audio)
					audio.pause()
					this.audioPaused = true
				}
			},
			initAudio() {
				//刚打开网站时弹框引导用户点击
				// this.$alert("允许网站播放声音", "提示", {
				//   confirmButtonText: "确定",
				//   showClose: false,
				//   callback: action => {
				//     this.playAudio();
				//   }
				// });
			},
			// playAudio() {
			//   //用户点击后，即可播放
			//   // if (this.isPlay) {
			//     this.$refs.audioVo.currentTime = 0; //从头开始播放提示音
			//     this.$refs.audioVo.play(); //播放
			//   // }
			// },
			// 播放音频结束事件
			playAudioEnd() {

			},
			// 播放失败
			playAudioError(e) {
				console.log('播放失败', e)
				// this.initAudio();
			},


			open() {

				var that = this
				that.showSlide = true
				that.showPage = true
				this.$nextTick(()=>{
					// this.play(1)
					mySwiper = new Swiper('.swiper-container2', {
						direction: "virtical",
						onInit: function(swiper) { //Swiper2.x的初始化是onFirstInit
							console.log("this", swiper)
							that.swiperAnimateCache(swiper); //隐藏动画元素
							that.swiperAnimate(swiper); //初始化完成开始动画

						},
						onSlideChangeEnd: function(swiper) {
							that.swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
							if (swiper.activeIndex == swiper.slides.length - 1) {

								//last page
								// that.show = false
							} else {
								// that.show = true

							}
						}
					})
				})

				if (!that.audioPaused) {
					that.$refs.audioVo.play(); //播放
				}

			},
			relook() {
				mySwiper.slideTo(0, 500, true);
			},
			arrowClick() {
				mySwiper.slideNext();
			},


			swiperAnimateCache(a) {
				var allBoxes = null
				var i = 0
				var j = 0
				var effect = null
				for (var j = 0; j < a.slides.length; j++)
					for (allBoxes = a.slides[j].querySelectorAll(".ani"), i = 0; i < allBoxes.length; i++) allBoxes[i]
						.attributes[
							"style"] ? allBoxes[i].setAttribute("swiper-animate-style-cache", allBoxes[i].attributes[
								"style"]
							.value) : allBoxes[i].setAttribute("swiper-animate-style-cache", " "), allBoxes[i].style
						.visibility =
						"hidden"
			},
			swiperAnimate(a) {
				var allBoxes = null
				var i = 0
				var j = 0
				var effect = null
				var style = null
				var duration = null
				var delay = null

				this.clearSwiperAnimate(a);
				var b = a.slides[a.activeIndex].querySelectorAll(".ani");
				for (var i = 0; i < b.length; i++) b[i].style.visibility = "visible", effect = b[i].attributes[
						"swiper-animate-effect"] ? b[i].attributes["swiper-animate-effect"].value : "", b[i].className = b[
						i]
					.className + "  " + effect + " " + "animated", style = b[i].attributes["style"].value, duration = b[i]
					.attributes["swiper-animate-duration"] ? b[i].attributes["swiper-animate-duration"].value : "",
					duration && (
						style = style + "animation-duration:" + duration + ";-webkit-animation-duration:" + duration + ";"
					), delay =
					b[i].attributes["swiper-animate-delay"] ? b[i].attributes["swiper-animate-delay"].value : "", delay &&
					(style =
						style + "animation-delay:" + delay + ";-webkit-animation-delay:" + delay + ";"), b[i].setAttribute(
						"style",
						style)
			},

			clearSwiperAnimate(a) {
				var allBoxes = null
				var i = 0
				var j = 0
				var effect = null
				for (var j = 0; j < a.slides.length; j++)
					for (var allBoxes = a.slides[j].querySelectorAll(".ani"), i = 0; i < allBoxes.length; i++) allBoxes[i]
						.attributes[
							"swiper-animate-style-cache"] && allBoxes[i].setAttribute("style", allBoxes[i].attributes[
							"swiper-animate-style-cache"].value), allBoxes[i].style.visibility = "hidden", allBoxes[i]
						.className =
						allBoxes[i].className.replace("animated", " "), allBoxes[i].attributes["swiper-animate-effect"] &&
						(effect =
							allBoxes[i].attributes["swiper-animate-effect"].value, allBoxes[i].className = allBoxes[i]
							.className
							.replace(effect, " "))
			},
			formatNumberWithCommas(number) {
				number += '';
				let [integer, decimal] = number.split('.');
				const doSplit = (num, isInteger = true) => {
					if (num === '') return '';
					if (isInteger) num = num.split('').reverse();
					let str = [];
					for (let i = 0; i < num.length; i++) {
						if (i !== 0 && i % 3 === 0) str.push(',');
						str.push(num[i]);
					}
					if (isInteger) return str.reverse().join('');
					return str.join('');
				};
				integer = doSplit(integer);
				decimal = doSplit(decimal, false);
				return integer + (decimal === '' ? '' : '.' + decimal);
			}

		}
	}
</script>

<style lang="less">
	.swiper-container {
		width: 100vw;
		height: 100vh;
		position: fixed;
		left: 0;
		top: 0;
	}
</style>
